import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, IconButton, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { FC } from "react";

const useStyles = makeStyles((theme: any) => ({
  container: {
    border: "1px solid rgba(255,255,255,0.5)",
    borderRadius: "50px",
    padding: "1px 5px",
    display: "flex",
    flexWrap: "nowrap",
    alignItems: "center",
    gap: "5px"

  }
}));

type Props = {
  label: string,
  onDelete: () => void,
  fileType: 'pdf' | 'image' | null,
  textColor: string
}

export const FileChip: FC<Props> = ({
  label,
  onDelete,
  fileType,
  textColor
}) => {
  const classes = useStyles();
  return (
    <Box className={classes.container}>
      <FontAwesomeIcon
        icon={fileType === 'pdf' ? 'file-pdf' : 'file-image'}
        style={{ color: "white !important" }}
        size="sm"
      />
      <Typography style={{ color: textColor, fontSize: "0.8rem" }}>{label.slice(0, 30)}</Typography>
      <IconButton
        onClick={onDelete}
        size="small"
      >
        <FontAwesomeIcon
          icon="times-circle"
          style={{ color: "white" }}
          size="sm"
        />
      </IconButton>
    </Box>
  );
};
